import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchLocationFromMaster,
  selectLocationFromMaster,
  setDataSuccess
} from 'src/features/staticDataSlice';
import LocationmasterCreateModal from 'src/pages/CustomerLocation/LocationmasterCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function LocationFromMaster({
  tableListDatas,
  index,
  customerId,
  saveRow,
  label,
  handleChange,
  apiUrl,
  customerType = 'corporate'
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [riskFactorCreatePermission, setRiskFactorCreatePermission] = useState(false);

  const riskFactorData = useSelector(selectLocationFromMaster);

  useEffect(() => {
    checkPermission(apiUrl.permission_key, 'Create').then((permission) => {
      setRiskFactorCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange(apiUrl.formKey, index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    setOpenCreateModal(false);
    fetchLocationFromMaster(customerId, apiUrl.get_url, customerType).then((data) =>
      dispatch(setDataSuccess({ dataType: apiUrl.formKey, data }))
    );
  };

  const error = false; // Add actual validation logic if needed

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id={`select-label-${apiUrl.formKey}`} error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId={`select-label-${apiUrl.formKey}`}
          id={`select-${apiUrl.formKey}`}
          value={tableListDatas[index]?.[apiUrl.formKey] || ''}
          onChange={(event) => {
            handleChange(apiUrl.formKey, index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {riskFactorData?.map((riskFactor) => (
            <MenuItem key={riskFactor?.name} value={riskFactor?.name}>
              {riskFactor?.name}
            </MenuItem>
          ))}
          <Tooltip
            title={
              riskFactorCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Location from master
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (riskFactorCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: riskFactorCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <LocationmasterCreateModal
          handleClose={handleClose}
          customerId={customerId}
          setNewValue={setNewValue}
          type={customerType}
        />
      )}
    </>
  );
}

export default LocationFromMaster;
